import styled from 'styled-components';

export const StyledFaqBanner = styled.div`
  min-height: 119px;
  box-shadow: 4px 6px 60px rgba(4, 86, 179, 0.1);
  margin-bottom: -22px; //compensate for negative margin of Scroller

  > div {
    max-width: 1440px;
    margin: auto;
    display: flex;
    align-items: center;
    column-gap: 24px;
    padding: 39px 68px 40px 121px;

    @media ${(props) => props.theme.device.tabletL} {
      padding: 32px 40px;
      margin-bottom: -13px; //compensate for negative margin of Scroller
    }

    @media ${(props) => props.theme.device.mobileL} {
      padding: 32px 39px;
      align-items: start;
      margin-bottom: -13px; //compensate for negative margin of Scroller
    }
  }
`;

export const TextContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    row-gap: 32px;
    align-items: start;
  }
`;
